import { register } from '@shopify/theme-sections'
import '../../styles/sections/index-accordion.scss'
import {renderAccordions} from '../modules/detail-accordion'


export default register(`index-accordion`, {
    onLoad() {
        renderAccordions(`index-accordion`)
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    },
})

